import { Link } from 'react-router-dom';
import { allTopics } from '@/utils/news';

export default function TopicCollection() {
  return (
    <div className="rounded-lg border border-background-200 bg-background-50 p-4">
      <h2 className="mb-4 flex items-center gap-2 font-heading text-lg font-bold text-foreground-900">
        <i className="ri-bookmark-3-fill text-primary-500"></i>
        推荐专题合集
      </h2>
      <div className="flex flex-col gap-3">
        {allTopics.map((topic) => (
          <Link
            key={topic.id}
            to={`/search?q=${encodeURIComponent(topic.tags[0])}`}
            className="group flex gap-3 rounded-md p-2 transition-colors hover:bg-background-100"
          >
            <div className="h-16 w-24 shrink-0 overflow-hidden rounded-md">
              <img
                src={topic.cover}
                alt={topic.title}
                title={`${topic.title} - 热搜榜专题`}
                className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-110"
              />
            </div>
            <div className="min-w-0 flex-1">
              <h3 className="line-clamp-1 text-sm font-bold text-foreground-900 transition-colors group-hover:text-primary-600">
                {topic.title}
              </h3>
              <p className="mt-1 line-clamp-2 text-xs leading-relaxed text-foreground-500">{topic.description}</p>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}